<template>
    <div>
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-title">
                    <h3>Detalhe Produto: {{product.name}} ({{product.product_id}})</h3>
                    <h4>{{product.web_name}}</h4>
                </div>
            </div>
            <div class="panel-body">
                <form id="form">
                    <div class="row">
                        <div class="col-md-12">
                            <img :src="product.photo" alt="Sem Foto" class="img-responsive img-thumbnail">

                            <hr>
                            <p>{{product.information}}</p>
                            <p :v-html="product.benefits"></p>
                            <br>
                            <br>
                            <h4>Informações Técnicas</h4>
                            <table class="table table-bordered table-striped">
                                <tbody>
                                <tr>
                                    <td>Descrição</td>
                                    <td>{{product.description}}</td>
                                </tr>
                                <tr>
                                    <td>Função</td>
                                    <td>{{product.goal}}</td>
                                </tr>
                                <tr>
                                    <td>Forma</td>
                                    <td>{{product.form}}</td>
                                </tr>
                                <tr>
                                    <td>Ingredientes</td>
                                    <td>{{product.ingredients}}</td>
                                </tr>
                                <tr>
                                    <td>Contém</td>
                                    <td>{{product.contains}}</td>
                                </tr>
                                <tr>
                                    <td>Advertência</td>
                                    <td>{{product.warning}}</td>
                                </tr>
                                <tr>
                                    <td>Dosagem</td>
                                    <td>{{product.dosage}}</td>
                                </tr>
                                <tr>
                                    <td>Modo de Preparo</td>
                                    <td>{{product.prepare_mode}}</td>
                                </tr>
                                <tr>
                                    <td>Registro no MS</td>
                                    <td>{{product.register}}</td>
                                </tr>
                                <tr>
                                    <td>Embalagem</td>
                                    <td>{{product.package}}</td>
                                </tr>
                                <tr>
                                    <td>Paletização</td>
                                    <td>{{product.pallet_ballast}} de lastro, e {{product.pallet_height}} de altura de
                                        empilhamento
                                    </td>
                                </tr>
                                <tr>
                                    <td>Armazenamento</td>
                                    <td>{{product.storage}}</td>
                                </tr>
                                <tr>
                                    <td>Validade</td>
                                    <td>{{product.shelf_life}}</td>
                                </tr>
                                <tr>
                                    <td>Código de Barras</td>
                                    <td>{{product.bar_code}}</td>
                                </tr>
                                </tbody>
                            </table>

                            <h4>Tabela Nutricional</h4>
                            <table class="table table-bordered table-striped">
                                <thead>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td>% VD (*)</td>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(nutrition,index) in product.nutritions">

                                    <td>{{nutrition.description}}</td>
                                    <td>{{nutrition.value}}</td>
                                    <td>{{nutrition.percentage}}</td>
                                </tr>
                                </tbody>
                            </table>

                            <p>
                                * % Valores diários com base em uma dieta de 2.000 kcal ou 8400 kJ. Seus valores diários
                                podem ser maiores ou menores, dependendo das suas necessidades energéticas.</p>
                            <p>** %VD Não estabelecido.</p>
                        </div>
                    </div>

                    <hr>

                    <h4>Recetuário</h4>
                    <ul>
                        <li v-for="recipe in product.recipes" v-if="recipe.recipe">
                            <router-link :to="'/recipe/view/' + recipe.recipe.id">{{ recipe.recipe.name }}</router-link>
                        </li>
                    </ul>

                    <hr>

                    <router-link to="/product" class="btn btn-info">Voltar</router-link>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                product: {},
                errors: []
            }
        },
        props: {},
        mounted: function () {
            const self = this;
            const id   = self.$route.params.id;
            const api  = self.$store.state.api;

            self.$http.get(api + 'product/' + id + '?disabled=true')
                .then((response) => {
                    self.product = response.data;
                })
                .catch((error) => {
                    self.$message(null, 'Ocorreu um erro ao buscar as informações do Produto');
                });

        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Product/View.vue